import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { MarkEmailUnread } from '@mui/icons-material';
import InvitationsList from './InvitationsList';
import AddInvitations from './AddInvitations';
import AnalyticsCard from '../../../../../components/Cards/AnalyticsCard';
import NoCreatedEvent from '../../../user-dashboard/my-events/NoCreatedEvent';
import LoadingSpinner from '../../../../../animation/LoadingSpinner';
import useAddInvitations from './hooks/useAddInvitations';
import '../../../../../styles/components/Invitation.css';

function InvitationManage() {
    const {
        invitations,
        loading
    } = useSelector((state) => state.invitation);

    const {
        formik,
        addInvitation,
        deleteInvitation,
        cancelAllForm,
        loading: addInviteLoading,
        openInvitationForm,
        setOpenInvitationForm,
        maxInviteLimit,
        openExcelUploadModal,
        setOpenExcelUploadModal,
        analyticsCards,
        fileInputRef,
        excelFileError,
        file,
        removeUploadedFile,
        handleFileInput,
        fileUploadStatus,
        submitExcelDataToForm,
        progress
    } = useAddInvitations();

    if (loading) {
        return <LoadingSpinner message="Fetching your invitations..." />;
    }

    if (invitations?.length === 0 && !openInvitationForm) {
        return (
            <NoCreatedEvent
                title="No invitations sent yet!"
                description='Add invitations to your event that helps with the check-in process.'
                btnName='Add Invitations'
                onClick={() => setOpenInvitationForm(true)}
                icon={<MarkEmailUnread color="tertiary" sx={{ fontSize: '48px' }} />}
            />
        )
    }

    return (
        <Fragment>
            <div className="manage-invitations-container">

                {(invitations?.length > 0 || openInvitationForm) && (
                    <div className="analytics-cards">
                        {analyticsCards.map((card, index) => (
                            <AnalyticsCard
                                key={index}
                                title={card.title}
                                value={card.value}
                                valueColor={card.valueColor}
                                iconBgColor={card.iconBgColor}
                                icon={card.icon}
                            />
                        ))}
                    </div>
                )}

                {(invitations?.length > 0 || openInvitationForm) && (
                    <AddInvitations
                        formik={formik}
                        addInvitation={addInvitation}
                        deleteInvitation={deleteInvitation}
                        cancelAllForm={cancelAllForm}
                        loading={addInviteLoading}
                        openInvitationForm={openInvitationForm}
                        maxInviteLimit={maxInviteLimit}
                        openExcelUploadModal={openExcelUploadModal}
                        setOpenExcelUploadModal={setOpenExcelUploadModal}
                        fileInputRef={fileInputRef}
                        excelFileError={excelFileError}
                        file={file}
                        removeUploadedFile={removeUploadedFile}
                        handleFileInput={handleFileInput}
                        fileUploadStatus={fileUploadStatus}
                        submitExcelDataToForm={submitExcelDataToForm}
                        progress={progress}
                    />
                )}

                {fileUploadStatus === 'loading' && (
                    <LoadingSpinner message="Uploading your excel file..." />
                )}

                {invitations?.length > 0 && fileUploadStatus !== 'loading' && (
                    <InvitationsList
                        invitations={invitations}
                    />
                )}
            </div>
        </Fragment>
    );
}

export default InvitationManage;